// src/browser-logger.ts
var LOG_LEVELS = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40
};
var CONSOLE_METHOD_NAMES = {
  debug: "debug",
  info: "info",
  warn: "warn",
  error: "error"
};
var sentryHook;
function setSentryBreadcrumbHook(hook) {
  sentryHook = hook;
}
function resolveArgs(contextOrMessage, maybeMessage) {
  if (typeof contextOrMessage === "string") {
    return { context: {}, message: contextOrMessage };
  }
  return { context: contextOrMessage, message: maybeMessage ?? "" };
}
function createBrowserLogFn(level, minLevel, bindings) {
  return (contextOrMessage, maybeMessage) => {
    if (LOG_LEVELS[level] < minLevel) return;
    const { context, message } = resolveArgs(contextOrMessage, maybeMessage);
    const merged = { ...bindings, ...context };
    const hasContext = Object.keys(merged).length > 0;
    const consoleFn = console[CONSOLE_METHOD_NAMES[level]];
    const formatted = `[${level.toUpperCase()}] ${message}`;
    if (hasContext) {
      consoleFn(formatted, merged);
    } else {
      consoleFn(formatted);
    }
    if (sentryHook && LOG_LEVELS[level] >= LOG_LEVELS.info) {
      sentryHook(level, message, hasContext ? merged : void 0);
    }
  };
}
function createBrowserLogger(options = {}, bindings = {}) {
  const level = options.level ?? "info";
  const minLevel = LOG_LEVELS[level];
  const baseBindings = options.service ? { service: options.service, ...bindings } : bindings;
  return {
    debug: createBrowserLogFn("debug", minLevel, baseBindings),
    info: createBrowserLogFn("info", minLevel, baseBindings),
    warn: createBrowserLogFn("warn", minLevel, baseBindings),
    error: createBrowserLogFn("error", minLevel, baseBindings),
    child: (childBindings) => createBrowserLogger(options, { ...baseBindings, ...childBindings })
  };
}
export {
  createBrowserLogger as createLogger,
  setSentryBreadcrumbHook
};
//# sourceMappingURL=browser.js.map